const AllNEETInfo = [

  {
    id: 1,
    subject: 'NEET Cutoff',
    name: 'NEET 2027 Cutoff',
    link: 'cutoff-2027',
    icon: '📊',
  },

  {
    id: 2,
    subject: 'NEET Exam Pattern',
    name: 'NEET 2027 Exam Pattern',
    link: 'exam-pattern-2027',
    icon: '📝',
  },

  {
    id: 3,
    subject: 'NEET Eligibility Criteria',
    name: 'NEET 2027 Eligibility Criteria',
    link: 'eligibility-criteria-2027',
    icon: '🎓',
  },
  {
    id: 4,
    subject: 'NEET Preparation',
    name: 'NEET 2027 Preparation',
    link: 'preparation-2027',
    icon: '📚',
  },
  {
    id: 6,
    subject: 'NEET FAQs',
    name: 'NEET 2027 FAQs',
    link: 'faq-2027',
    icon: '❓',
  },

];

export default AllNEETInfo;